import { useCallback, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import KakaoShareButton from './kakao';
import FacebookShareButton from './facebook';
import UrlShareButton from './url';
import { InfoContentType } from '@domain/rs/info/InfoCardListRs';
import { useScrollDocOffset } from '@utils/hooks/useScroll';
import classnames from 'classnames/bind';
import styles from './infoDetailArticleShareGorup.module.scss';

const cx = classnames.bind(styles);

interface InfoDetailArticleShareGroupProps {
  type: InfoContentType | null;
  title: string;
  label: string;
  thumbnailUrl: string;
}

const FLOATING_MIN_TOP = 228;
const FLOATING_MENU_HEIGHT = 200;

const InfoDetailArticleShareGroup = (props: InfoDetailArticleShareGroupProps) => {
  const { type, title, label, thumbnailUrl } = props;
  const router = useRouter();
  const [url, setUrl] = useState('');
  const [floatingStyle, setFloatingStyle] = useState('');
  const floatingMenu = useRef<HTMLUListElement>(null);

  const floating = useCallback(() => {
    const scrollTop = document.documentElement.scrollTop;
    const parentHeight = floatingMenu.current?.parentElement?.scrollHeight;
    const maxFloating = Math.round(parentHeight ? parentHeight - FLOATING_MIN_TOP - FLOATING_MENU_HEIGHT : 0);

    if (type !== InfoContentType.TEXT) {
      return;
    } else if (scrollTop < maxFloating) {
      const transformSize = Math.round(scrollTop);
      setFloatingStyle(`translateY(${transformSize}px)`);
    } else {
      setFloatingStyle(`translateY(${maxFloating}px`);
    }
  }, [type]);

  useEffect(() => {
    // Router 내 현재 페이지의 Full URL을 가져올 수 없어서 window 객체를 활용하여 작업하였습니다.
    setUrl(window.location.href);
  }, [router]);

  useScrollDocOffset(floating, 0, 0, [floating]);

  return (
    <ul
      ref={floatingMenu}
      className={cx('shareGroup', { floating: type === InfoContentType.TEXT })}
      style={{ transform: floatingStyle }}
    >
      <KakaoShareButton title={title} description={label} imageUrl={thumbnailUrl} webUrl={url} mobileWebUrl={url} />
      <FacebookShareButton title={title} url={url} />
      <UrlShareButton url={url} />
    </ul>
  );
};

export default InfoDetailArticleShareGroup;
